import React from 'react';

const NotFound = () => {
  return (
    <div>
      <h1>404 - Page Not Found</h1>
      <p>متأسفانه صفحه‌ای که به دنبال آن هستید وجود ندارد.</p>
    </div>
  );
};

export default NotFound;